import { useInitOrderRequest } from 'components/payment/payment.new.hooks';
import { useSpreedlyCheckoutSdkScriptLoading } from 'components/payment/spreedly-checkout-sdk/spreedly-checkout-sdk-script-loading.hooks';
import { useURLSearchParams } from 'hooks/useURLSearchParams';

export const useSpreedlyHosted = () => {
  const urlSearchParams = useURLSearchParams();
  const { loading: spreedlyScriptLoading, error: spreedlyScriptError } =
    useSpreedlyCheckoutSdkScriptLoading();

  // Once the script hook gives up (loading turns false) after a load
  // failure — e.g. an SRI/CORS mismatch in a native WebView — loading alone
  // can't tell that apart from a successful load, leaving the form below to
  // call into window.SpreedlyHostedFields, which never got defined.
  // Throwing here, synchronously during render rather than from an effect,
  // means this component's own render aborts before React ever gets to
  // mount the form's children — an effect-based throw fires after child
  // effects (React commits child effects before parent effects), by which
  // point the form's own effect has already called the missing
  // constructor. The payment error boundary still catches a render-phase
  // throw the same way.
  if (!!spreedlyScriptError)
    throw new Error(
      `Spreedly script loading error: ${spreedlyScriptError.message}`,
    );

  const initOrderBody = {
    attributes: {},
    otherData: null,
    orderId: urlSearchParams.get('orderId'),
    locationId: urlSearchParams.get('locationId'),
    merchantId: urlSearchParams.get('merchantId'),
  };

  const { loading, setLoading, initOrderResponse, refetchInitOrder } =
    useInitOrderRequest(initOrderBody, {
      headers: { CLIENTID: urlSearchParams.get('clientId') },
    });

  return {
    loading,
    setLoading,
    initOrderResponse,
    refetchInitOrder,
    spreedlyScriptLoading,
  };
};
